import React, { useContext, useState, PureComponent } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import Input from '../components/forms/Input';
import Button from '../components/forms/Button';
import { initializeApp } from "firebase/app";
import { setToLocalStorage } from '../components/helper/auth'
import {
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
    sendEmailVerification,
    updatePassword,
    isSignInWithEmailLink,
    signInWithEmailLink,
} from "firebase/auth";
import {
    getFirestore,
    query,
    getDocs,
    collection,
    where,
    addDoc,
} from "firebase/firestore";
import { firebaseConfig } from "../firebaseConfig"
import { AuthContext } from '../context/auth';
import { useNavigate, Link } from 'react-router-dom';

export default function Rest() {

    const [authc, setAuth] = useContext(AuthContext);
    console.log(authc)
    const [password, setPassword] = useState("");

    const navigate = useNavigate();
    const app = initializeApp(firebaseConfig);
    const auth = getAuth();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        if (isSignInWithEmailLink(auth, window.location.href)) {
            // Additional state parameters can also be passed via URL.
            // This can be used to continue the user's intended action before triggering
            // the sign-in operation.
            // Get the email if available. This should be available if the user completes
            // the flow on the same device where they started it.
            let email = window.localStorage.getItem('emailForSignIn');
            if (!email) {
                // User opened the link on a different device. To prevent session fixation
                // attacks, ask the user to provide the associated email again. For example:
                email = window.prompt('Please provide your email for confirmation');
                
            }
            // The client SDK will parse the code from the link for you.
            signInWithEmailLink(auth, email, window.location.href)
                .then(async (userCredential) => {
                    // Clear email from storage.
                    window.localStorage.removeItem('emailForSignIn');
                    // You can access the new user via result.user
                    // Additional user info profile not available via:
                    // result.additionalUserInfo.profile == null
                    // You can check if the user is new or existing:
                    // result.additionalUserInfo.isNewUser
                    setAuth(userCredential.user)
                    setToLocalStorage("auth",userCredential.user)
                    
                })
                .catch((error) => {
                    console.log(error)
                    // Some error occurred, you can inspect the code: error.code
                    // Common errors could be invalid email and invalid or expired OTPs.
                });
        }
        try {
            const user = await auth.currentUser;
            if (!user) {
                toast.error("userXXXXXXXXXX")
                return;
            }
            updatePassword(user, password).then(async (userCredential) => {
                toast.success("Password Reset ")

                setTimeout(() => {
                    navigate('/dashboard')
                }, 2000)

            }).catch((error) => {
                setLoading(false)
                //   toast.error("User do not exist ")

                setTimeout(() => {
                    navigate('/register')
                }, 2000)
                const errorCode = error.code;
                const errorMessage = error.message;
            });
        } catch (error) {
            setLoading(false)
            console.log(error);
        }
    }
    return (

        <div style={{ margin: "100px" }} className='d-flex justify-content-center align-items-center vh-100' >
            <Toaster />
            <div className='container'>
                <div className='row'>
                    <div className='col-md-6 offset-md-3'>
                        <h1 className='fw-bold mb-3'>Rest password</h1>

                        <form>
                            <Input value={password} setValue={setPassword} label="Password" type="password" />
                            <Button handleSubmit={handleSubmit}
                                className={"btn btn-primary"}
                                type={"submit"}
                                text={"Submit"}
                                password={password}

                                loading={loading} />
                        </form>

                    </div>

                </div>

            </div>

            <pre>                       {JSON.stringify({ password }, null, 4)}</pre>

        </div>
    )

}

